import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
} from "react-bootstrap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import "../css/home.css";
import { getcmsAction } from "../../../Action/user.action";

const Ticketterms = () => {
  const [ticketterms, setticketterms] = useState({
    ticket_terms:""
  });
  useEffect(() => {
    tickettermsFun();
    // setcondition();
  }, []);

  const tickettermsFun = async () => {
    let res = await getcmsAction("ticketterms");
    if (res.success) {
      setticketterms(res.data);
    } else {
    }
  };

  // const navigateToPackagePlan = () => {

  //   navigate(`${config.baseUrl}packageplan`)
  // }

  return (
    <>
      <div className="lighttheme overflow-hidden hero" style={{ minHeight: "100vh" }}>
        <section className="herobanner position-relative text-white overflow-hidden" style={{backgroundColor:"black"}}>
          <Container>
            <Row className="align-items-center">
              <div className="jovitClass"
                dangerouslySetInnerHTML={{
                  __html: ticketterms.ticket_terms,
                }}
              />
            </Row>
          </Container>
        </section>
      </div>

      
    </>
  );
};
export default Ticketterms;
